import { Box, Skeleton, Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

const SKELETON_ROW_COUNT = 3;

interface TableLoadingIndicatorProps {
  columns: string[];
}

export function TableLoadingIndicator({ columns }: TableLoadingIndicatorProps) {
  return (
    <Box
      style={{
        overflow: "hidden",
        borderRadius: "var(--mantine-radius-md)",
        border: "1px solid var(--mantine-color-cream-4)",
      }}
    >
      <Table withRowBorders verticalSpacing="md" borderColor="cream.4" horizontalSpacing="md">
        <Table.Thead bg="cream.3">
          <Table.Tr>
            {columns.map((column) => (
              <Table.Th key={column}>
                <TextWrapper c="dark.9" variant="bold">
                  {column}
                </TextWrapper>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {Array.from({ length: SKELETON_ROW_COUNT }).map((_, rowIndex) => (
            <Table.Tr key={rowIndex}>
              {columns.map((_, colIndex) => (
                <Table.Td key={colIndex}>
                  <Skeleton height={20} radius="xs" />
                </Table.Td>
              ))}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
}
